import {
  DeletePaymentAPIResponse,
  BaseReducerState,
} from '../../../services'
import { ActionTypes } from '../actions'

export type DeletePaymentState = BaseReducerState & {
  data: boolean
}

const deletePaymentInitialState: DeletePaymentState = {
  loading: false,
  success: false,
  message: '',
  data: null,
  error: null,
}

export const deletePayment = (
  state: DeletePaymentState = deletePaymentInitialState,
  action: { type: string; res: any }
): DeletePaymentState => {
  switch (action.type) {
    case `${ActionTypes.DELETE_PAYMENT}_REQUEST`:
      return {
        ...state,
        loading: true,
        success: false,
        message: null,
        data: null,
        error: null,
      }

    case `${ActionTypes.DELETE_PAYMENT}_SUCCESS`: {
      const { success, data, message } = <DeletePaymentAPIResponse>action.res
      return {
        ...state,
        loading: false,
        success,
        message,
        ...(success && data && { data }),
      }
    }
    case `${ActionTypes.DELETE_PAYMENT}_FAILURE`:
      const res = <DeletePaymentAPIResponse>action.res
      const { message } = res || {}
      res.error ??= message
      const { error } = res
      return {
        ...state,
        loading: false,
        success: false,
        message,
        error,
      }

    case `${ActionTypes.DELETE_PAYMENT}_RESET`:
      return {
        ...state,
        loading: false,
        success: false,
        message: null,
        data: null,
        error: null,
      }
  }
  return state
}
